import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { formats } from '~/helper';
import Modal from '~/components/modal';
import DataTable from '~/components/datatable';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100%);

  span {
    color: #d61305;
    margin: 0 0 10px;
  }

  img {
    max-width: 100px;
    max-height: 100px;
    align-self: center;
    display: flex;
  }
`;

const getStatus = (row) => {
  if (row.blacklist) {
    return 'Pessoa está na blacklist';
  }
  if (!_.isEmpty(row.errors)) {
    return 'Não será importado';
  }
  return (!_.get(row, 'person.id')) ? 'Será cadastrado' : 'Será atualizado';
};

const columns = [
    {
      name: 'CPF/Número de Registro',
      width: '180px',
      selector: 'company',
      format: (row) => formats.cpf(_.get(row, 'person.identify')) || _.get(row, 'person.identify') || ''
    },
    {
      name: 'Nome',
      selector: 'person.name'
    },
    {
      name: 'Função',
      selector: 'person',
      format: (row) => _.get(row, 'person.role.name')
    },
    {
      name: 'Email',
      selector: 'person.email'
    },
    {
      name: 'Telefone',
      selector: 'person.phone',
      format: (row) => formats.phone(_.get(row, 'person.phone'))
    },
    {
      name: 'Situação',
      selector: 'status',
      format: (row) => getStatus(row)
    },
    {
      name: 'Campo(s) não preenchido(s)',
      selector: 'errors',
      format: (row) => (!_.isEmpty(row.errors)) ? row.errors.join(', ') : ''
    }
  ];

function ImportModal({ title, previewMode, isOpen, loading, closeModal, handleOnSubmit, data, handleExportErrors }) {
  let errors = _.filter(data, (r) => !r.blacklist && !_.isEmpty(r.errors)),
    blacklist = _.filter(data, (r) => r.blacklist),
    updates = _.filter(data, (r) => !r.blacklist && _.isEmpty(r.errors) && !!_.get(r, 'person.id')),
    imports = _.filter(data, (r) => !r.blacklist && _.isEmpty(r.errors) && !_.get(r, 'person.id'));

  return (
    <Modal
      width="90%"
      height="80%"
      open={isOpen}
      hide={closeModal}
      title={title}
      actions={[
        {
          label: 'Cancelar',
          action: () => { closeModal() },
          disabled: loading
        },
        {
          label: loading ? 'Aguarde...' : 'Baixar planilha de erros',
          action: () => handleExportErrors([ ...errors ]),
          type: 'submit',
          primary: true,
          disabled: loading || _.isEmpty(errors)
        },
        {
          label: loading ? 'Aguarde...' : 'Importar',
          action: () => handleOnSubmit([ ...imports, ...updates ]),
          type: 'submit',
          primary: true,
          disabled: loading || (_.isEmpty(imports) && _.isEmpty(updates))
        }
      ]}
      >
      <Container>
        <DataTable
          columns={columns}
          data={{ rows: [ ...imports, ...updates, ...blacklist, ...errors ] }}
          noPagination={true}
          emptyText="Nenhum colaborador encontrado"
          onRowClicked={_.noop}
          extraOptions={{
            ignoreRowClicked: true,
            selectableRows: false,
            selectableRowsHighlight: false,
          }}
          />
      </Container>
    </Modal>
  );
};

export default ImportModal;
